import { Input } from "../../../../../common/Input"

export const MRFInformation = ({ data }) => {
  return (
    <>
      <div className="rounded-lg bg-white p-6 shadow-md">
        <div className="space-y-6">
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-800">MRF Request Details</h3>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <Input
                label="Position Title"
                value={data?.position?.description || ""}
                isDisabled={true}
              />
              <Input
                label="Department"
                value={data?.department?.description || ""}
                isDisabled={true}
              />
              <Input
                label="Number of Vacancies"
                value={data?.numberOfVacancies || ""}
                isDisabled={true}
              />
              <Input
                label="Requested Date"
                value={data?.requestedDate || ""}
                isDisabled={true}
              />
              <Input
                label="Target Start Date"
                value={data?.targetStartDate || ""}
                isDisabled={true}
              />
            </div>
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-600">
              Required Qualifications
            </label>
            <div className="min-h-[80px] rounded-md border border-gray-300 bg-gray-50 p-3">
              <p className="text-sm text-gray-700">{data?.qualification || "No qualifications specified"}</p>
            </div>
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-600">
              Requester Notes
            </label>
            <div className="min-h-[60px] rounded-md border border-gray-300 bg-gray-50 p-3">
              <p className="text-sm text-gray-700">{data?.requesterNotes || "No notes provided"}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}